import { RematchDispatch } from '@rematch/core';
import { axiosErrorHandler } from 'common/helpers';
import { IRootModel } from 'app/store';
import { IEventListParams, IEventPayload } from 'entities/Events/Event.models';
import { eventService } from 'entities/Events/Event.service';

export const eventListEffects = (dispatch: RematchDispatch<IRootModel>) => ({
  async getEventList(params: IEventListParams) {
    dispatch.eventList.setLoading(true);

    try {
      const response = await eventService.getEventList(params);
      dispatch.eventList.setList(response.data);
      dispatch.eventList.setCount(response.meta.count);
    } catch (error) {
      axiosErrorHandler(error);
    } finally {
      dispatch.eventList.setLoading(false);
    }
  },
});

export const eventEffects = (dispatch: RematchDispatch<IRootModel>) => ({
  async getEventById(id: number) {
    dispatch.event.setLoading(true);

    try {
      const response = await eventService.getEventById(id);
      dispatch.event.setEvent(response);
      return response;
    } catch (error) {
      axiosErrorHandler(error);
      return null;
    } finally {
      dispatch.event.setLoading(false);
    }
  },
  async reviewEvent(payload: IEventPayload) {
    dispatch.event.setLoading(true);
    dispatch.eventList.setWatchUpdates(false);
    dispatch.statistics.setWatchUpdates(false);

    try {
      const response = await eventService.reviewEvent(payload.id);
      dispatch.event.setEvent(response);
      dispatch.global.onSuccess(payload);
    } catch (error) {
      axiosErrorHandler(error);
    } finally {
      dispatch.event.setLoading(false);
    }
  },
  async moveEventToInbox(payload: IEventPayload) {
    dispatch.event.setLoading(true);

    try {
      await eventService.moveEventToInbox(payload.id);
      dispatch.global.onSuccess(payload);
    } catch (error) {
      axiosErrorHandler(error);
    } finally {
      dispatch.event.setLoading(false);
    }
  },
  async completeEvent(payload: IEventPayload) {
    dispatch.event.setLoading(true);

    try {
      await eventService.completeEvent(payload);
      dispatch.global.onSuccess(payload);
    } catch (error) {
      axiosErrorHandler(error);
    } finally {
      dispatch.event.setLoading(false);
    }
  },
  clearEvent() {
    dispatch.event.setEvent(null);
    dispatch.event.setAction(null);
    dispatch.event.setText(null);
    dispatch.event.setPhysicianId(null);
    dispatch.patient.setPatient(null);
    dispatch.eventList.setWatchUpdates(true);
    dispatch.statistics.setWatchUpdates(true);
    dispatch.timer.clearTimer();
    dispatch.patientMetrics.setAssessmentHistory([]);
  },
});
